import { FC, useEffect } from 'react';
import { useBreadcrumbLeaf } from 'utils/breadcrumbLeaf';
import { setBasePageTitle } from 'utils/documentTitle';
import { useRecordRecentlyViewed } from 'utils/recentlyViewed';

type PageTitleProps = {
    title?: string;
    showBreadcrumb?: boolean;
    breadcrumbContent?: string;
};

const PageTitle: FC<PageTitleProps> = ({ title, showBreadcrumb, breadcrumbContent }) => {
    useEffect(() => {
        setBasePageTitle(title ?? 'Crespect');
        return () => {
            setBasePageTitle('Crespect');
        };
    }, [title]);

    const content = breadcrumbContent ?? title;
    // The dynamic tail crumb now lives in a store keyed by route, not a <meta> tag
    // watched with a MutationObserver: the leaf's structure is route-driven, so this
    // only feeds its text (empty content contributes no leaf, matching the old guard).
    useBreadcrumbLeaf(showBreadcrumb ? content || undefined : undefined);
    // Every page names itself here, so this is the one place that knows both which record a URL is
    // showing and what it is called — global search's recently-viewed list is written from it
    // rather than from a call in each detail page. Pages whose URL carries no record id are ignored.
    useRecordRecentlyViewed(content || undefined);

    return null;
};

export default PageTitle;
